/** Живой эфир волны (MADR 0040). */
import { Empty } from "../errors";
import type { EndpointDef } from "../endpoint";
import { LiveChunk } from "../../live";

export const liveEndpoints = {
  /** Текущая волна игрока для зрителя; ничего не меняет, ответ пустой. */
  live: { method: "POST", path: "/api/live/chunk", request: LiveChunk, response: Empty, auth: true },
} as const satisfies Record<string, EndpointDef>;
